import { render, staticRenderFns } from "./DateFilter.vue?vue&type=template&id=3ca87485&scoped=true&"
import script from "./DateFilter.vue?vue&type=script&lang=js&"
export * from "./DateFilter.vue?vue&type=script&lang=js&"
import style0 from "./DateFilter.vue?vue&type=style&index=0&id=3ca87485&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca87485",
  null
  
)

export default component.exports